import { RootState } from 'src/store';

export const selectAccessToken = (state: RootState) => state.backendAuth.accessToken;
export const selectCurrentUser = (state: RootState) => state.backendAuth.user;
